export function isMobile() {
  const userAgent = navigator.userAgent
  const mobileRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i
  const tabletRegex = /iPad|Android Tablet|Kindle|Silk|PlayBook|BB10/i
  return mobileRegex.test(userAgent) && !tabletRegex.test(userAgent)
}
